import { define, email, is, nullable, optional } from '@subaio/validation'

import type { DefaultFields } from './DefaultProps'

export const fieldEmail = ({
	requiredErrorMessage = 'This field is required',
	invalidErrorMessage = 'Has to be a valid email',
}: DefaultFields = {}) =>
	define<string>('fieldEmail', (value) => {
		const isValidEmail = is(value, optional(email()))
		if (!isValidEmail) return invalidErrorMessage
		if (is(value, email())) return true
		return requiredErrorMessage
	})

export const fieldEmailOptional = ({
	invalidErrorMessage = 'Has to be a valid email',
}: Pick<DefaultFields, 'invalidErrorMessage'> = {}) =>
	define<string | undefined | null>(
		'fieldEmailOptional',
		(value) => is(value, optional(nullable(email()))) || invalidErrorMessage,
	)
